export enum MicrositeEventType {
    ReadyForTransplant = 0,
    ReceivedLivingKidney = 1,
    ReceivedDeceasedKidney = 2,
    ReceivedVoucher = 3,
    TooSick = 4,
    TooHealthy = 5,
    Died = 6,
    DuplicateEntry = 7,
    MovedNewCenter = 8,
    NotResponsive = 9,
    DecidedAgainstTransplant = 10,
    LivingTxpOtherCenter = 11,
    CoachTransplantNotification = 12,
    NeverAcceptedInvite = 13,
    NoLongerEnrolled = 14,
    PatientDeactivateRequest = 15,
    ReceivedDeceasedKidneyOtherCenter = 16,
    ContactAttempted = 17,
    ContactMade = 18,
    OtherDeactivate = 200,
    Other = 300
}

export enum ReasonType {
    Transplanted = 1,
    Other = 2,
    Deactivate = 3,
    Contact = 4,
    Reactivate = 5
}

export const transplantEventTypes: MicrositeEventType[] = [
    MicrositeEventType.ReceivedLivingKidney,
    MicrositeEventType.LivingTxpOtherCenter,
    MicrositeEventType.ReceivedDeceasedKidney,
    MicrositeEventType.ReceivedDeceasedKidneyOtherCenter,
    MicrositeEventType.ReceivedDeceasedKidneyOtherCenter
]